module.exports={
  "climate": {
    "climate-issue-1": {
      "climate-issue-1-answer-4": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "climate-issue-2": {
      "climate-issue-2-answer-2": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "climate-issue-3": {
      "climate-issue-3-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "climate-issue-4": {
      "climate-issue-4-answer-3": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    }
  },
  "economics": {
    "economics-issue-1": {
      "economics-issue-1-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "economics-issue-2": {
      "economics-issue-2-answer-1": [
        {
          "slug": "karen-bass",
          "quote": "We must protect our rent-controlled housing stock, and expand just cause eviction protections to non-rent controlled multifamily properties.",
          "date": ""
        }
      ]
    },
    "economics-issue-3": {
      "economics-issue-3-answer-3": [
        {
          "slug": "karen-bass",
          "quote": "I am concerned that if the eviction moratorium is lifted too soon, it will cause more Angelenos to fall into homelessness. At the same time, I believe that we must protect our mom and pop landlords, many of whom face unique challenges exacerbated by the pandemic. The city should help ensure these apartment owners receive the financial support they need to stay afloat and continue to house Angelenos.",
          "date": ""
        }
      ]
    },
    "economics-issue-4": {
      "economics-issue-4-answer-2": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "economics-issue-5": {
      "economics-issue-5-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        },
        {
          "slug": "rick-caruso",
          "quote": "I am always interested in innovative solutions to solving inequality. I am open to seeing the results of the City’s and County’s programs and seeing if there are real tangible results.",
          "date": ""
        }
      ]
    }
  },
  "homelessness": {
    "homelessness-issue-1": {
      "homelessness-issue-1-answer-2": [
        {
          "slug": "karen-bass",
          "quote": "I support the intent of 41.18 – it is unacceptable for encampments to exist near schools and child care centers. I have a problem with 41.18’s district by district, encampment by encampment approach. We need coordinated, citywide leadership to solve this problem, and we need to ensure that housing and services are available for homeless individuals because what I will never accept is simply moving an encampment from one neighborhood to another. That’s not a solution – that’s whack a mole.",
          "date": ""
        },
        {
          "slug": "rick-caruso",
          "quote": "I will build 30,000 shelter beds in 300 days with supported services to get people off our streets and provide them with the help they need to get back on their feet. I will also enforce 41.18 to keep people from turning our parks, sidewalks, and bus shelters into encampments.",
          "date": ""
        }
      ]
    },
    "homelessness-issue-2": {
      "homelessness-issue-2-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "homelessness-issue-3": {
      "homelessness-issue-3-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ],
      "homelessness-issue-3-answer-2": [
        {
          "slug": "rick-caruso",
          "quote": "I think a significant percentage of our homeless crisis is driven by those who are mentally ill and suffer from substance abuse. Whether they directly make our city less safe is debatable, but they do make people feel less safe outside, at our parks, or walking down the street. We need to get people housed, we need to get them services, and for those who can not make rational decisions for themselves due to mental illness we need a Cares Court now.",
          "date": ""
        }
      ]
    },
    "homelessness-issue-4": {
      "homelessness-issue-4-answer-6": [
        {
          "slug": "karen-bass",
          "quote": "I will immediately address the homelessness crisis by building more interim and permanent housing, rebuilding the mental health and substance abuse systems, and providing unhoused Angelenos with job training and employment assistance.",
          "date": ""
        }
      ]
    }
  },
  "policing": {
    "policing-issue-1": {
      "policing-issue-1-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ],
      "policing-issue-1-answer-2": [
        {
          "slug": "rick-caruso",
          "quote": "The LAPD is the smallest big city police force per capita in the US and that must change. I will add 1,500 officers to our force before the end of his first term. My administration will apply for every federal and state grant there is and even demand more direct funding from the Biden administration and Governor Newsom to expand and strengthen our police force and ensure they are trained properly and engaged with the communities they serve.",
          "date": ""
        }
      ]
    },
    "policing-issue-2": {
      "policing-issue-2-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ],
      "policing-issue-2-answer-2": [
        {
          "slug": "rick-caruso",
          "quote": "I will restore the LAPD’s budget and expand the number of patrol officers with more hiring, civilianization of non-essential sworn positions, and a commitment to more training and diversified recruitment.",
          "date": ""
        }
      ]
    },
    "policing-issue-3": {
      "policing-issue-3-answer-1": [
        {
          "slug": "karen-bass",
          "quote": "I will immediately increase co-response and alternative response teams that include mental health, homeless outreach and other specialists who can respond to people in distress, freeing officers to focus on crime.",
          "date": ""
        }
      ]
    },
    "policing-issue-4": {
      "policing-issue-4-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        },
        {
          "slug": "rick-caruso",
          "quote": "I am willing to meet with anyone and listen to their concerns and solutions.",
          "date": ""
        }
      ]
    },
    "policing-issue-5": {
      "policing-issue-5-answer-2": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "policing-issue-6": {
      "policing-issue-6-answer-2": [
        {
          "slug": "karen-bass",
          "quote": "Accountability starts at the top. I will be a hands-on Mayor who looks for leaders who embrace accountability, are committed to preventing and reducing crime, and increasing mutual trust between officers and communities. I will lay out clear goals and expectations for the Police Chief and Police Commission – and I will expect them to meet those goals. As Mayor, I will invest in Senior Lead Officers and proven programs like the Community Safety Partnership to build trust between officers and the communities they serve – and I will double down on investments in crime prevention programs that address the root causes of crime.",
          "date": ""
        }
      ]
    }
  }
}